import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const sfGeoJson = {
  "type": "Feature",
  "properties": { "name": "San Francisco" },
  "geometry": {
    "type": "Polygon",
    "coordinates": [[
      [-122.5247, 37.7081],
      [-122.3570, 37.7081],
      [-122.3570, 37.8324],
      [-122.5247, 37.8324],
      [-122.5247, 37.7081]
    ]]
  }
};

const Links = () => (
  <div style={{ height: "100vh" }}>
    <MapContainer center={[37.7749, -122.4194]} zoom={12} style={{ height: "100%", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <GeoJSON data={sfGeoJson} style={{ color: "red", weight: 2, fillOpacity: 0.3 }} />
    </MapContainer>
  </div>
);

export default Links;